import React from "react";
import { useHistory } from "react-router-dom";
import RelativeContainer from "../containers/RelativeContainer";
import AbsoluteContainer from "../containers/AbsoluteContainer";

const NotFoundPage = ({ width, height }) => {
  const history = useHistory();

  return (
    <RelativeContainer
      style={{
        width,
        minHeight: height,
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: "#f8f9fa",
      }}
    >
      <AbsoluteContainer
        style={{
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          padding: "40px",
          textAlign: "center",
        }}
      >
        <h1
          style={{
            fontSize: "120px",
            fontWeight: "bold",
            color: "#333",
            margin: "0",
            lineHeight: "1",
          }}
        >
          404
        </h1>
        <h2
          style={{
            fontSize: "28px",
            color: "#666",
            margin: "20px 0",
            fontWeight: "normal",
          }}
        >
          Page Not Found
        </h2>
        <p
          style={{
            fontSize: "16px",
            color: "#888",
            marginBottom: "40px",
            maxWidth: "400px",
          }}
        >
          The page you're looking for doesn't exist or has been moved.
        </p>
        <button
          onClick={() => history.push("/")}
          style={{
            padding: "12px 32px",
            fontSize: "16px",
            fontWeight: "500",
            color: "#fff",
            backgroundColor: "#000",
            border: "none",
            borderRadius: "6px",
            cursor: "pointer",
            transition: "background-color 0.2s",
          }}
          onMouseOver={(e) => (e.target.style.backgroundColor = "#0056b3")}
          onMouseOut={(e) => (e.target.style.backgroundColor = "#000")}
        >
          Go Home
        </button>
      </AbsoluteContainer>
    </RelativeContainer>
  );
};

export default NotFoundPage;
